import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { StatusTag, statusTone } from "@/components/shared/Primitives";
import { revealStaggered, VIEW_NEAR } from "@/components/shared/motion";

export const ProjectCard = ({ project, index = 0, offset = false }) => (
  <motion.div
    variants={revealStaggered}
    initial="hidden"
    whileInView="show"
    viewport={VIEW_NEAR}
    custom={(index % 2) * 0.12}
    className={offset && index % 2 === 1 ? "lg:mt-20" : ""}
  >
    <Link
      to={`/work/${project.slug}`}
      data-testid={`showcase-item-${project.slug}`}
      aria-label={`View the ${project.title} case study`}
      className="group block focus-visible:outline-none"
    >
      <div className="relative overflow-hidden rounded-2xl border border-white/10 shadow-[0_24px_70px_rgba(0,0,0,0.55)] transition-colors duration-500 group-hover:border-[#8B5CF6]/40 group-focus-visible:border-[#06B6D4]">
        <img
          src={project.image}
          alt={project.alt}
          loading="lazy"
          decoding="async"
          className="h-72 w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-[1.06] md:h-[24rem]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0C10] via-[#0B0C10]/30 to-transparent" />
        <div className="absolute left-5 top-5 flex flex-wrap gap-2">
          <StatusTag tone={statusTone(project.status)}>{project.status}</StatusTag>
        </div>
        <div className="absolute inset-x-5 bottom-5 md:inset-x-7 md:bottom-7">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#06B6D4]">
            {project.capability}
          </p>
          <div className="mt-3 flex items-end justify-between gap-5">
            <div>
              <h3 className="font-display text-xl font-bold uppercase tracking-tight text-[#F4F6FB] md:text-2xl">
                {project.title}
              </h3>
              <p className="mt-2 max-w-md text-sm leading-relaxed text-[#F4F6FB]/60">
                {project.oneLiner}
              </p>
              <span className="mt-4 inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.3em] text-[#F4F6FB]/70 transition-colors duration-300 group-hover:text-[#F4F6FB]">
                View Case Study
                <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </span>
            </div>
            <span className="hidden font-mono text-[10px] uppercase tracking-[0.3em] text-[#F4F6FB]/35 md:block">
              {project.year}
            </span>
          </div>
        </div>
      </div>
    </Link>
  </motion.div>
);

export default ProjectCard;
